// eslint-disable-next-line
import React, { ReactNode, FC } from 'react';
import DOMPurify from 'dompurify';
import Error from '@material-ui/icons/Error';
import Info from '@material-ui/icons/Info';
import Warning from '@material-ui/icons/Warning';
import CheckCircle from '@material-ui/icons/CheckCircle';
import { useTheme } from '@material-ui/core/styles';
import dictionary from 'utils/dictionary';
import { AlertIcon, AlertPaper, AlertBox, AlertLink } from './Alert.styles';

export type AlertProps = {
  type?: 'success' | 'warning' | 'info' | 'error';
  text: string | ReactNode;
  reload?: () => void;
};

type Props = AlertProps;
/**
 * Show three alerts with different styles 'warning' | 'information' | 'error'.
 *
 * @example
 * <Alert text="I'm a text" type="info">
 */

const iconTypes = {
  success: <CheckCircle />,
  info: <Info />,
  warning: <Warning />,
  error: <Error />,
};

const Alert: FC<Props> = ({ type = 'info', text, reload }) => {
  const theme = useTheme();

  const createContent = () => {
    if (typeof text === 'string') {
      const purifyText = DOMPurify.sanitize(text);
      return <AlertBox dangerouslySetInnerHTML={{ __html: purifyText }} />;
    }

    return <AlertBox>{text}</AlertBox>;
  };

  return (
    <AlertPaper $type={type} $theme={theme} elevation={0} role="alert">
      <AlertIcon $theme={theme} fontSize="small" component={iconTypes[type]} />
      {createContent()}
      {type === 'error' && reload && (
        <AlertLink
          $theme={theme}
          aria-label={dictionary.alert_alertLink_label}
          variant="inherit"
          onClick={reload}
        >
          Vuelva a intentarlo
        </AlertLink>
      )}
    </AlertPaper>
  );
};

export default Alert;
